import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    item: {
        background: '#fff',
        height: '100%',
        maxWidth: '100%'
    },
    contentWrapper: {
        flex: 1,
        overflowY: 'scroll',
        marginLeft: -1,
        borderLeft: '1px solid #E0E0E0',
        borderRight: '1px solid #E0E0E0',
        scrollBehavior: 'smooth',
        scrollbarWidth: 'none', // Firefox
        '&::-webkit-scrollbar': {
            display: 'none' // Safari and Chrome
        },
        '@media (max-width: 460px)': {
            border: 'none'
        }
    },
    content: {
        padding: '40px 60px',
        borderBottom: '1px solid #E0E0E0',
        '& hr': {
            display: 'block',
            background: '#E0E0E0',
            height: 1,
            border: 0
        },
        '@media (max-width: 460px)': {
            padding: 20
        }
    },
    related: {
        padding: '80px 60px 60px',
        '@media (max-width: 460px)': {
            padding: '60px 20px 40px'
        }
    },
    privateArea: {
        borderBottom: '1px solid #E0E0E0',
        padding: 60,
        '@media (max-width: 460px)': {
            padding: 20
        }
    },
    searchInput: {
        background: '#F5F5F5'
    },
    score: {
        boxSizing: 'border-box',
        width: 340,
        overflowY: 'scroll',
        padding: '60px 30px 30px',
        scrollbarWidth: 'none',
        transition: 'all 0.2s ease-out',
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        '@media (max-width: 1024px)': {
            width: 0,
            display: 'none'
        }
    }
});
